import { render, staticRenderFns } from "./PopupTextBody.vue?vue&type=template&id=498e7e70&scoped=true"
import script from "./PopupTextBody.vue?vue&type=script&lang=js"
export * from "./PopupTextBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498e7e70",
  null
  
)

export default component.exports